// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"707ce803c7c9b502","1677":"b58a72da4541e6a5","2937":"e7601066ca3501ac"}[chunkId] + ".js";
};